/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */

import * as Services from '@services';
import {
  ClearVehicleReminder,
  CreateUpdateVehicleReminder,
  PagedRequestReminder,
  Reminder,
  VehicleReminder,
} from '@services';
import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';

class ReminderStore {
  reminder: Reminder | undefined;
  reminders = new Map<number, Reminder>();
  serviceReminders = new Map<number, Reminder>();
  overdueVehicleReminderCount: number = 0;
  vehicleReminders = new Map<number, VehicleReminder>();
  orderReminders = new Map<number, VehicleReminder>();
  loading: boolean = false;
  serviceRemindersLoading: boolean = false;
  vehicleLoading: boolean = false;
  orderLoading: boolean = false;
  overdueCount: number = 0;
  overdueLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getAll(filter: PagedRequestReminder) {
    this.setLoading(true);
    try {
      const result = await Services.ReminderService.getAll(filter);
      runInAction(() => {
        result.items.forEach((reminder) => {
          this.reminders.set(reminder.id, reminder);
        });
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  async getAllServiceReminders(filter: PagedRequestReminder) {
    this.setServiceRemindersLoading(true);
    try {
      const result = await Services.ReminderService.getAll(filter);
      runInAction(() => {
        result.items.forEach((reminder) => {
          this.serviceReminders.set(reminder.id, reminder);
        });
      });
      this.setServiceRemindersLoading(false);
    } catch (error) {
      this.setServiceRemindersLoading(false);
      console.error(error);
    }
  }

  async createOrUpdateVehicleReminder(request: CreateUpdateVehicleReminder) {
    try {
      const result = await Services.ReminderService.createOrUpdateVehicleReminder(request);
      runInAction(() => {
        this.orderReminders.set(result.id, result);
        this.vehicleReminders.set(result.id, result);
      });
      message.success({
        content: 'Successfully updated!',
      });
    } catch (error) {
      message.error({
        content: 'Failed to update!',
      });
    }
  }

  async clearVehicleReminder(request: ClearVehicleReminder) {
    try {
      await Services.ReminderService.clearVehicleReminder(request);
      runInAction(() => {
        this.orderReminders.delete(request.id);
        this.vehicleReminders.delete(request.id);
      });
      message.success({
        content: 'Successfully updated!',
      });
    } catch (error) {
      message.error({
        content: 'Failed to update!',
      });
    }
  }

  async getVehicleReminders(vin: string) {
    this.setVehicleLoading(true);
    try {
      const result = await Services.ReminderService.getVehicleReminders(vin);
      runInAction(() => {
        result.forEach((reminder) => {
          this.vehicleReminders.set(reminder.id, reminder);
        });
      });
      this.setVehicleLoading(false);
    } catch (error) {
      this.setVehicleLoading(false);
      console.error(error);
    }
  }

  async getOverdueReminderCount(vin: string) {
    this.setOverdueLoading(true);
    try {
      const result = await Services.ReminderService.getOverdueReminderCount(vin);
      runInAction(() => {
        this.overdueCount = result;
      });
      this.setOverdueLoading(false);
    } catch (error) {
      this.setOverdueLoading(false);
      console.error(error);
    }
  }

  async getOrderReminders(vin: string) {
    this.setOrderLoading(true);
    try {
      const result = await Services.ReminderService.getVehicleReminders(vin);
      runInAction(() => {
        result.forEach((reminder) => {
          this.orderReminders.set(reminder.id, reminder);
        });
      });
      this.setOrderLoading(false);
    } catch (error) {
      this.setOrderLoading(false);
      console.error(error);
    }
  }

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  setServiceRemindersLoading = (value: boolean) => {
    runInAction(() => {
      this.serviceRemindersLoading = value;
    });
  };

  setVehicleLoading = (value: boolean) => {
    runInAction(() => {
      this.vehicleLoading = value;
    });
  };

  setOverdueLoading = (value: boolean) => {
    runInAction(() => {
      this.overdueLoading = value;
    });
  };

  setOrderLoading = (value: boolean) => {
    runInAction(() => {
      this.orderLoading = value;
    });
  };

  clearReminders = () => {
    runInAction(() => {
      this.reminders.clear();
    });
  };

  clearServiceReminders = () => {
    runInAction(() => {
      this.serviceReminders.clear();
    });
  };

  clearVehicleReminders = () => {
    runInAction(() => {
      this.vehicleReminders.clear();
    });
  };

  clearOrderReminders = () => {
    runInAction(() => {
      this.orderReminders.clear();
    });
  };

  clearOverdueCount = () => {
    runInAction(() => {
      this.overdueCount = 0;
    });
  };
}

export default ReminderStore;
